<template>
    <select
        :id="param"
        :name="param"
        v-model="val"
        class="form-control form-control-lg bg-light col-3"
    >
        <option></option>
        <option>Single</option>
        <option>Married</option>
        <option>Widowed</option>
        <option>Separated</option>
        <option>Divorced</option>
        <option>Domestic Partner</option>
    </select>
</template>

<script>
export default {
    name: "InputMarriage",
    props: ["param", "value"],
    data: function() {
        return {};
    },

    computed: {
        val: {
            get: function() {
                return this.value;
            },
            set: function(newValue) {
                this.$parent.update(this.param, newValue);
            },
        },
    },
};
</script>
